module.exports = __webpack_public_path__ + "static/media/facility-01.748335a2.jpg";